import {Box, Modal} from "@mui/material";
import {MySelector} from "../../redux/store";
import {desc, returnStyle, title} from "../../utils/popupModalStyle";
import {useLocation} from "react-router-dom";
import lockIcon from '../../assets/lock.svg';
import lockDarkIcon from '../../assets/lock_gold.svg'
import {useEffect, useState} from "react";

const ExpiredSubscription = () => {
  const location = useLocation()

  const {theme} = MySelector((state) => state.theme)
  const {category, data} = MySelector(state => state.event)

  const [open, setOpen] = useState<boolean>(false)

  useEffect(() => {
    if (!data?.expiryDate) return

    const expiry = new Date(data?.expiryDate);
    expiry.setHours(23, 59, 59, 999);
    const subscriptionExpiry = new Date(data?.subscription?.endDate)
    subscriptionExpiry.setHours(23, 59, 59, 999);
    const today = new Date();
    const diffInTime = expiry.getTime() - today.getTime();
    const subscriptionDiffInTime = subscriptionExpiry.getTime() - today.getTime();
    if (diffInTime < 0 || subscriptionDiffInTime < 0) setOpen(true);
    // const diffInDays = diffInTime / (1000 * 3600 * 24);
    //
    // if (diffInDays <= 15) setOpen(true);
  }, [data?.expiryDate, data?.subscription?.endDate]);

  if (location.pathname.includes("auth") || !category || !data || !data.expiryDate) return null;

  return (
    <Modal
      aria-details="expiry-modal"
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{...returnStyle(theme), width: "min(90%, 625px)"}}>
        <div className="p-5 md:px-[26.11px] md:py-[33.25px]">
          <div className="flex justify-center">
            <img src={theme === "dark" ? lockDarkIcon : lockIcon} alt="" className='h-[48px] w-[48px] mb-5'/>
          </div>
          <p
            className={title}>{category === "host" ? "Your gallery has expired !" : "Gallery currently unavailable!"}</p>
          <p
            className={desc}>{category === "host" ? "To continue enjoying your wedding memories, please contact your photographer." : "This gallery is no longer accessible. Please reach out to the event host for more information."}</p>
        </div>
      </Box>

    </Modal>
  )
}

export default ExpiredSubscription